import { createFileRoute } from "@tanstack/react-router"
import { ActivityPage } from "@/features/operations/activity-page"
import { validateActivitySearch } from "@/features/operations/operations-search"
export const Route = createFileRoute("/_authenticated/activity")({
    validateSearch: validateActivitySearch,
    component: ActivityPage,
})
